// @flow
import React from 'react';
import {useGuide} from '../../data/GuideProvider';
import {instructions} from '../../content/checkout/build/index';
import Shell from './Shell';

export function RunServerCommandShell() {
  const guide = useGuide();
  const {server} = guide.languages.active;
  const config = instructions[server];
  if (config && config.run) {
    return <Shell command={config.run} />;
  }
  return null;
}
